import {
  fetchCompanyCrunchbaseDataByCrunchbaseId,
  type SavvyCrunchbaseOrganizationResponse,
} from '@/api/v4/crunchbase.api';
import { QueryKey } from '@/config/query-client';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

export const useCompanyData = (
  crunchbaseId?: string,
  options?: Omit<
    UseQueryOptions<
      SavvyCrunchbaseOrganizationResponse,
      Error,
      SavvyCrunchbaseOrganizationResponse,
      readonly string[]
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: [QueryKey.CompanySavvyCrunchbase, crunchbaseId ?? ''],
    queryFn: () => fetchCompanyCrunchbaseDataByCrunchbaseId(crunchbaseId!),
    enabled: !!crunchbaseId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...options,
  });
};
